<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card :loading="loading" icon="mdi-account" icon-small title="لیست وام ها" color="accent">
			<v-row v-if="!userloans || userloans.length == 0">
				<v-col cols="12">
					<div class="red--text text-h4 text-center">
						تاکنون وامی برای شما ثبت نشده است.
					</div>
				</v-col>
			</v-row>
			<v-row v-else class="loan-cards">
				<v-col v-for="l in userloans" :key="l.id" cols="12" md="12">
					<v-card class="mx-2 overflow-hidden" outlined elevation="1">
						<div class="checkouted-mark" v-if="l.isCheckouted">تسویه شده</div>
						<div class="checkouted-mark" v-if="l.isCanceled">فسخ شده</div>
						<v-row>
							<v-col cols="12" md="6">
								<v-list-item three-line class="manage-loan-detail">
									<v-list-item-content>
										<v-list-item-title class="headline mb-3 pb-2 secondary--text"
											style="border-bottom: 1px dashed rgb(191 191 191);">
											<span class="black--text">نوع وام:</span> {{ l.loanModel.title }}
										</v-list-item-title>

										<v-list-item-subtitle class="secondary--text"><span class="black--text">شماره
												پرونده:</span> {{ l.code }}</v-list-item-subtitle>
										<v-list-item-subtitle class="secondary--text"><span class="black--text">شماره
												فرعی:</span> {{ l.secondaryCode || 'ندارد' }}</v-list-item-subtitle>
										<v-list-item-subtitle class="secondary--text"><span class="black--text">تاریخ
												شروع:</span> {{ l.startDate_Persian.date }}</v-list-item-subtitle>
										<v-list-item-subtitle class="secondary--text"><span class="black--text">مبلغ
												وام:</span> {{ l.amount.toString().toPriceFormat() }}
											تومان</v-list-item-subtitle>
										<v-list-item-subtitle class="secondary--text"><span class="black--text">مبلغ وام
												با بهره:</span> {{ (l.month * l.installment).toString().toPriceFormat()
											}} تومان</v-list-item-subtitle>
										<v-list-item-subtitle class="secondary--text"><span class="black--text">تعداد
												اقساط:</span> {{ l.month }} {{ (l.monthGap > 1 ? `قسط ${l.monthGap}
											ماهه` : "") }}</v-list-item-subtitle>
										<v-list-item-subtitle class="secondary--text"><span class="black--text">مبلغ
												قسط:</span> {{ l.installment.toString().toPriceFormat() }}
											تومان</v-list-item-subtitle>
										<v-list-item-subtitle class="secondary--text"><span class="black--text">مبلغ پیش
												پرداخت:</span> {{ l.preDepositAmount.toString().toPriceFormat() }}
											تومان</v-list-item-subtitle>

									</v-list-item-content>
								</v-list-item>
							</v-col>
							<v-col cols="12" md="6">
								<v-list-item three-line>
									<v-list-item-content>
										<v-list-item-title class="headline mb-3 pb-2"
											style="border-bottom: 1px dashed rgb(191 191 191);">
											بازپرداخت ها
										</v-list-item-title>
										<v-list-item-subtitle class="secondary--text"><span class="black--text">تعداد
												اقساط پرداختی:</span> {{ l.paidCount }}</v-list-item-subtitle>
										<v-list-item-subtitle class="secondary--text"><span class="black--text">اقساط
												پرداخت شده:</span> {{ l.paid.toString().toPriceFormat() }}
											تومان</v-list-item-subtitle>
										<v-list-item-subtitle>
											<span v-if="l.delays === 0" class="">دیرکرد زودکرد:</span>
											<span v-else-if="l.delays > 0" class="black--text">دیرکرد:</span>
											<span v-else class="black--text">زودکرد:</span>
											<span class="mr-1"
												:class="l.delays > 0 ? 'red--text' : l.delays < 0 ? 'success--text' : ''">{{
													Math.abs(l.delays).toString().toPriceFormat() }} تومان</span>
										</v-list-item-subtitle>
										<v-list-item-subtitle class="">
											<span :class="[l.discount === 0 ? '' : 'black--text']">
												تخفیف:
											</span>
											<span :class="[l.discount === 0 ? '' : 'secondary--text']">{{
												l.discount.toString().toPriceFormat() }} تومان</span>
										</v-list-item-subtitle>
										<v-list-item-subtitle class="secondary--text"><span class="black--text">مبلغ
												باقیمانده:</span> {{ Math.abs(l.remain).toString().toPriceFormat() }}
											تومان <span class="success--text" v-if="l.remain < 0">بستانکار</span><span
												class="red--text"
												v-if="l.remain > 0">بدهکار</span></v-list-item-subtitle>
										<v-list-item-subtitle class="secondary--text"><span class="black--text">تسویه
												شده:</span> {{ l.isCheckouted ? 'بلی' : 'خیر' }}</v-list-item-subtitle>
										<v-list-item-subtitle class="secondary--text" v-if="l.isCheckouted">
											<span class="black--text">تاریخ تسویه:</span> {{ l.checkoutDate_Persian.date
											}}
										</v-list-item-subtitle>
									</v-list-item-content>

								</v-list-item>
							</v-col>
						</v-row>
						<v-card-actions>
							<v-btn color="secondary" rounded @click="showInstallments(l)">
								مشاهده اقساط
							</v-btn>
							<v-btn outlined rounded text @click="showCheckoutAmount(l)">
								تسویه بدهی
							</v-btn>
						</v-card-actions>
					</v-card>
				</v-col>
			</v-row>

			<v-dialog v-model="dialogInstallments" scrollable max-width="1000px">
				<v-card>
					<v-card-title>
						<span class="headline">لیست اقساط</span>
						<v-spacer />
						<v-btn @click="dialogInstallments = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-card-text>
						<v-container>
							<loan-installments v-if="dialogInstallments" ref="installments"
								:data="{ userloan: selectedUserLoan }" @back="activeTab = 0" area="member" />
						</v-container>
					</v-card-text>
					<v-card-actions>
						<v-spacer />
						<v-btn @click="dialogInstallments = false">
							بستن
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-dialog v-model="dialogCheckoutAmount" max-width="400px">
				<v-card>
					<v-card-title>
						<div><span class="headline">تسویه بدهی</span></div>
						<v-spacer />
						<v-btn @click="dialogCheckoutAmount = false" icon>
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</v-card-title>
					<v-container>
						<div style="text-align:center">
							<div class="mb-2">مبلغ قابل تسویه:</div>
							<h3 :class="[checkoutAmount > 0 ? 'red--text' : 'success--text']">
								{{ checkoutAmount.toString().toPriceFormat() }} <span v-if="!isNaN(checkoutAmount)">{{
									checkoutAmount > 0 ?
										'بدهکار' : 'بستانکار' }}</span></h3>
						</div>
						<div class="text-center my-3" v-if="checkoutAmount > 0 && isOnlinePaymentActive">
							<v-btn color="secondary" @click="checkoutOnline()" :loading="checkoutOnlineLoading">
								<v-icon dark class="ml-1">
									mdi-credit-card-outline
								</v-icon>
								پرداخت آنلاین
							</v-btn>
						</div>
					</v-container>
				</v-card>
			</v-dialog>

		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import LoanInstallments from '../admin/LoanInstallments.vue'
	import { get } from 'vuex-pathify'

	export default {
		name: 'MemberLoansView',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
			'loan-installments': LoanInstallments,
		},
		data() {
			return {
				errorMessages: '',
				localData: {},
				selectedUserLoan: {},
				dialogInstallments: false,
				search: '',
				userloans: [],
				loading: true,
				checkoutOnlineLoading: false,
				dialogCheckoutAmount: false,
				checkoutAmount: 0
			}
		},
		computed: {
			...get('memberAppSettings', [
				'isOnlinePaymentActive',
			])
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData() {
				this.loading = true
				api.get('member/userloan/get', null)
					.then(
						response => {
							this.userloans = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => {
						this.loading = false
					})
			},
			showInstallments(item) {
				this.selectedUserLoan = item
				this.dialogInstallments = true
			},
			loadInstallments(loan) {
				return api.get('admin/loanpayment/getLoanPayments/' + loan.id, null)
					.catch(err => {
						toast.error(err.message)
					}).finally(x => {
						this.checkoutOnlineLoading = false
					})
			},
			checkoutOnline() {
				if (this.checkoutAmount <= 0) {
					toast.error('مبلغ قابل تسویه باید بیشتر از 0 باشد.')
					return
				}
				this.checkoutOnlineLoading = true
				this.loadInstallments(this.selectedUserLoan).then(payments => {
					let payment = payments.find(x => x.amount === 0) || payments[payments.length - 1]

					let data = {
						amount: this.checkoutAmount,
						userLoanPayment: payment,
						memberPurchaseType: 5,
						customerCode: 0
					}
					let url = 'member/purchase/create'
					api.post(url, data)
						.then(response => {
							if (response.gateway === 'sep') {
								let form = document.getElementById('sepForm')
								let sepToken = document.getElementById('sepToken')
								sepToken.value = response.token
								form.submit()
							}
							else if (response.gateway === 'sepehr') {
								let form = document.getElementById('sepehrForm')
								let sepehrToken = document.getElementById('sepehrToken')
								sepehrToken.value = response.token
								let sepehrTerminal = document.getElementById('sepehrTerminalId')
								sepehrTerminal.value = response.terminalId
								form.submit()
							}
							else {
								window.location.replace(response.gatewayUrl)
							}
						})
						.catch(err => {
							this.checkoutOnlineLoading = false
							toast.error(err.message)
						})
				})
				// ابتدا اولین قسط باز در غیر اینصورت آخرین قسط را برای پرداخت انتخاب کن

			},
			showCheckoutAmount(loan) {
				this.dialogCheckoutAmount = true
				this.selectedUserLoan = loan
				this.checkoutAmount = "در حال دریافت اطلاعات..."
				api.get('member/userloan/getCheckoutAmount/' + loan.id, null)
					.then(
						response => {
							this.checkoutAmount = response
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
		},
	}
</script>
<style></style>
